<div class="popover" [nbSpinner]="loading()">
  <nb-icon icon="person-outline" pack="eva"></nb-icon>
  <div class="description">
    <div class="title">
      {{user?.firstName}} {{user?.lastName}}
    </div>
    <div class="subtitle">{{user?.tenant?.name}}</div>
    <div class="subtitle" *ngIf="user && user.teams">Teams: {{ getTeamText(user.teams) }}</div>
    <div class="subtitle">{{user?.email}}</div>
  </div>
  <button nbButton size="small" (click)="navigateToDetail()" *ngIf="!disableLink">
    <nb-icon icon="external-link" pack="eva"></nb-icon>
  </button>
</div>
